const XP_BASE = 1000;
const XP_MULTIPLIER = 1.1;

export const xpForLevel = (level) => Math.floor(XP_BASE * Math.pow(XP_MULTIPLIER, level));

export const getLevelInfo = (xp = 0) => {
  let level = 0;
  let remaining = xp;
  while (remaining >= xpForLevel(level)) {
    remaining -= xpForLevel(level);
    level++;
  }
  const nextLevelXP = xpForLevel(level);
  return { level, currentXP: remaining, nextLevelXP, progress: remaining / nextLevelXP };
};

export const GRADES = [
  { id: 'f2',         label: 'Pilote de F2',       icon: '🏎️',  minLevel:  0, color: '#71717a', bg: '#71717a18' },
  { id: 'rookie',     label: 'Rookie',              icon: '🎯',  minLevel:  2, color: '#60a5fa', bg: '#60a5fa18' },
  { id: 'gds',        label: 'Gros Début de Saison', icon: '🔥', minLevel: 10, color: '#a855f7', bg: '#a855f718' },
  { id: 'challenger', label: 'Challenger',          icon: '⚡',  minLevel: 20, color: '#f97316', bg: '#f9731618' },
  { id: 'champion',   label: 'Champion',            icon: '🏆',  minLevel: 30, color: '#e10600', bg: '#e1060018' },
  { id: 'legende',    label: 'Légende',             icon: '👑',  minLevel: 40, color: '#facc15', bg: '#facc1518' },
];

/* Pass the numeric level (from getLevelInfo) */
export const getGrade = (level = 0) => {
  for (let i = GRADES.length - 1; i >= 0; i--) {
    if (level >= GRADES[i].minLevel) return GRADES[i];
  }
  return GRADES[0];
};
